/* src/app/ship/access-points-dialog/access-points-dialog.component.scss */
.dialog-header {
  position: relative;
  padding: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: flex-start;
}
.dialog-header .mat-mdc-dialog-title {
  font-size: 1.2rem;
  font-weight: 700;
  margin: 0;
  padding: 0;
}
.dialog-header a {
  font-size: 0.875rem;
  font-weight: 600;
  text-decoration-line: underline;
  line-height: 1.5;
  padding: 0 0.75em;
}
.dialog-header .close-icon {
  position: absolute;
  top: 0.75em;
  right: 0.5em;
}
.dialog-content .content {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
}
.dialog-content .content .search {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  flex: 1;
}
.dialog-content .content .search .origin {
  font-size: 0.8rem;
  padding: 1rem;
}
.dialog-content .content .search .origin .origin-title {
  font-weight: 700;
}
.dialog-content .content .search .origin .origin-address {
  font-weight: 500;
}
.dialog-content .content .search .search-parameters {
  font-size: 0.8rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  background-color: rgba(0, 0, 0, 0.04);
  padding: 0 0.5rem;
}
.dialog-content .content .search .search-parameters .search-parameter {
  width: 100%;
  padding: 0 0.5rem;
}
@media screen and (min-width: 48rem) {
  .dialog-content .content .search .search-parameters .search-parameter {
    width: auto;
  }
}
.dialog-content .content .search .search-parameters .search-parameter.range {
  position: relative;
}
.dialog-content .content .search .search-parameters .search-parameter.range mat-label {
  position: absolute;
  top: 0;
  left: 0;
  transform: translateX(-1.75em) translateY(0.3em) scale(0.75) perspective(100px) translateZ(0.001px);
  width: 133.3333333333%;
  color: rgba(0, 0, 0, 0.58);
}
.dialog-content .content .search .search-parameters .search-parameter.range .range-text {
  display: inline-block;
  padding-top: 1.5rem;
}
.dialog-content .content .search .search-parameters .search-parameter.record-count {
  width: 8rem;
  margin-top: 1rem;
}
.dialog-content .content .search .search-parameters .search-parameter.record-count ::ng-deep .mat-mdc-form-field {
  width: 100%;
}
.dialog-content .content .search .search-parameters .search-parameter.record-count ::ng-deep .mat-mdc-form-field.mat-form-field-appearance-outline {
}
.dialog-content .content .search .search-parameters .search-parameter.record-count ::ng-deep .mat-mdc-form-field.mat-form-field-appearance-outline .mat-select-arrow-wrapper {
  transform: none;
}
.dialog-content .content .search .search-results {
  padding: 1rem;
  height: 19rem;
  overflow: auto;
}
.dialog-content .content .search .search-results ul.access-points {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.dialog-content .content .search .search-results ul.access-points li.access-point:not(:last-of-type) {
  border-bottom: solid thin #dfdbd7;
}
.dialog-content .content .search .search-results ul.access-points li.access-point ::ng-deep .mat-mdc-radio-button {
  width: 100%;
}
.dialog-content .content .search .search-results ul.access-points li.access-point ::ng-deep .mat-mdc-radio-button .mat-radio-label-content {
  padding-left: 1rem;
  width: 100%;
}
.dialog-content .content .search .search-results ul.access-points li.access-point .option-content {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
}
.dialog-content .content .search .search-results ul.access-points li.access-point .option-content .location {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  justify-content: space-between;
  font-size: 0.8rem;
  line-height: 1.2;
  width: 100%;
}
.dialog-content .content .search .search-results ul.access-points li.access-point .option-content .location .address {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  min-width: 10rem;
}
.dialog-content .content .search .search-results ul.access-points li.access-point .option-content .location .address h4 {
  font-size: 1.2em;
  font-weight: 700;
}
.dialog-content .content .search .search-results ul.access-points li.access-point .option-content .location .distance {
  padding-top: 2em;
}
.dialog-content .content .search .search-results ul.access-points li.access-point .option-content .office-hours-wrapper {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.5;
  padding-top: 1em;
}
.dialog-content .content .map {
  display: none;
}
.dialog-content .content .map:empty {
  flex: 0;
  min-width: 0;
}
@media screen and (min-width: 48rem) {
  .dialog-content .content .map {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    flex: 2;
  }
}
.dialog-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  justify-content: space-around;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  padding: 1rem;
  position: sticky;
  bottom: 0;
  background-color: white;
  z-index: 99;
}
.dialog-actions .dialog-action {
  width: 25%;
  padding: 1rem 2rem;
  font-family: "Roboto Flex", sans-serif;
}
:host(.access-points-dialog) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  height: 100vh;
  position: relative;
}
@media screen and (min-width: 48rem) {
  :host(.access-points-dialog) {
    height: auto;
    min-width: 21.5rem;
  }
}
/*# sourceMappingURL=access-points-dialog.component.css.map */
